<template>
    <div class="content">
        <organization org='LATAM'/>
    </div>
</template>

<script>
    import Organization from 'src/components/organization.vue'
    export default {
        components: {
            Organization
        },
        methods: {
        },
        data: function () {
            return {
            }
        }
    }
</script>